import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
const _excluded = ["submitQuery"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { setCancelBookingError } from "@Redux/bookTable/BookTable.actions";
import actions from "./actions";
import { getContactNameFromFirstNameAndLastName } from "@Components/BookTable/MainBookATable/Pages/useGetBooking";
import { format, parseISO } from "date-fns";
export const begin = () => async function thunk(dispatch) {
  dispatch(actions.reset());
  dispatch(actions.begin({}));
};
export const submitSearch = payload => async function thunk(dispatch) {
  const {
    when
  } = payload;
  if (when) {
    const finalDate = when.date.replace("00:00", when.hour);
    dispatch(actions.search.submit(_objectSpread(_objectSpread({}, payload), {}, {
      finalDate
    })));
  } else {
    throw new Error("date or search are not deined correctfully");
  }
};
export const setSearch = payload => async function thunk(dispatch) {
  dispatch(actions.search.submit(_objectSpread({}, payload)));
};
export const editBooking = payload => async function thunk(dispatch) {
  dispatch(actions.booking.edit(_objectSpread({}, payload)));
};
export const submitBooking = payload => async function thunk(dispatch, getState) {
  const {
      submitQuery
    } = payload,
    data = _objectWithoutProperties(payload, _excluded);
  await dispatch(actions.booking.edit(_objectSpread(_objectSpread({}, data), {}, {
    submitting: true
  })));
  const {
    bookTable: {
      booking
    }
  } = getState();
  const hourSplit = booking.when.hour.split(":")[0] + ":" + booking.when.hour.split(":")[1];
  const hourFormat = hourSplit.length === 5 ? "T".concat(hourSplit, ":00") : "T0".concat(hourSplit, ":00");
  try {
    const {
      data: {
        book_a_table: data
      }
    } = await submitQuery({
      variables: {
        // replace hour in date
        date: format(parseISO(booking.when.date), "yyyy-MM-dd") + hourFormat,
        ls_store_id: booking.store.id,
        contact_name: booking.who.contact_name,
        contact_email: booking.who.contact_email,
        notes: booking.quantity.notes ? booking.quantity.notes : "",
        request_cane: !!booking.quantity.request_cane,
        request_seggiolino: !!booking.quantity.request_seggiolino,
        request_disabili: !!booking.quantity.request_disabili,
        request_laurea: !!booking.quantity.request_laurea,
        request_compleanno: !!booking.quantity.request_cake,
        number_of_people: booking.quantity.quantity_internal,
        contact_phone_number: booking.who.contact_phone_number,
        contact_id: booking.contact_id ? booking.contact_id : ""
      }
    });
    if (data.error_string || data.error) throw data.error_string || data.error;
    dispatch(actions.booking.accept(_objectSpread(_objectSpread({}, booking), {}, {
      item_no: data.item_no,
      id: data.id
    })));
    return data;
  } catch (e) {
    console.error(e);
    dispatch(actions.booking.reject(e));
  }
};
export const editExistingBooking = payload => async function thunk(dispatch, getState) {
  const {
    deleteQuery,
    createQuery
  } = payload;
  try {
    // Delete booking
    await deleteQuery({
      variables: {
        booking_id: payload.id
      }
    });

    // Create a new one
    const {
      data: {
        book_a_table: data
      }
    } = await createQuery({
      variables: _objectSpread(_objectSpread({}, payload), {}, {
        // replace hour in date
        date: payload.date.replace(/T.*$/, "T" + payload.hour)
      })
    });
    if (data.error_string || data.error) throw data.error_string || data.error;
    return data;
  } catch (e) {
    console.error(e);
  }
};
export const deleteExistingBooking = payload => async function thunk(dispatch) {
  const {
    deleteQuery
  } = payload;
  try {
    // Delete booking
    await deleteQuery({
      variables: {
        booking_id: payload.id
      }
    });
    return true;
  } catch (e) {
    console.error(e);
    dispatch(setCancelBookingError(e));
  }
};
export const reset = () => async function thunk(dispatch) {
  dispatch(actions.reset());
};